import React from 'react';
import { Link } from 'react-router-dom';

export default function FormNav({ formSelected, setFormSelected }) {
    return (
        <aside className="navbar-gaia">
            <div className="sticky top-0">
                <ul className="fa-ul flex flex-col mt-3 ml-2 sticky">
                    <div id="brand-container" class="flex flex-col justify-center items-center">
				        <image height="50px" width="50px" src={"/Group_99.svg"} alt="GAIA icon" />
		                <span class="navbar-brand-text">GAIA</span>
		            </div>
                    <li role="navigation" className="nav-link-item">
                        <Link className="flex" to="/version">
                            <span>
                                <i className="fas fa-search"></i>
                            </span>
                            <span className="navbar-hidden">Select by version</span>
                        </Link>
                    </li>
                    <li role="navigation" className="nav-link-item">
                        <Link className="flex" to="/newVersion">
                            <span>
                                <i className="fas fa-plus"></i>
                            </span>
                            <span className="navbar-hidden">Create new version</span>
                        </Link>
                    </li>
                    <li role="navigation" className="nav-link-item">
                        <Link className="flex" to="/queryBuilder">
                            <span>
                                <i className="fas fa-wrench"></i>
                            </span>
							<span className="navbar-hidden">Build a new scheduled query</span>
                        </Link>
                    </li>
                    <li role="navigation" className="nav-link-item">
                        <Link className="flex" to="/queryResults">
                            <span>
                                <i className="fas fa-warehouse"></i>
                            </span>
							<span className="navbar-hidden">Scheduled query results</span>
                        </Link>
                    </li>
                    <li role="navigation" className="nav-link-item">
                        <Link className="flex" to="/connectionCreation">
                            <span>
                                <i className="fas fa-wifi"></i>
                            </span>
							<span className="navbar-hidden">ODBC Connection Creation</span>
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="flex flex-col p-3 mb-5 sticky bottom-0">
                    <a className="nav-link-item" href="https://gaiadev3.systematrix.ai">GAIA</a>
            </div>
        </aside>
    )
}
